const subscriptionNameHasValue = (subscriptionName) => {
  if (!subscriptionName) {
    throw new Error("Subscription name field is required and cannot be empty");
  }
}
const subscriptionNameDoesExceedMaxLength = (subscriptionName) => {
  if (subscriptionName?.length > 40) {
    throw new Error("Subscription name must not exceed 40 characters");
  }
}

export const validateSubscriptionName = (subscriptionName) => {
  let feValidationErrors = [];

  try {
    subscriptionNameHasValue(subscriptionName)
  } catch (error) {
    feValidationErrors.push(error.message);
  }
  try {
    subscriptionNameDoesExceedMaxLength(subscriptionName)
  } catch (error) {
    feValidationErrors.push(error.message);
  }

  if (feValidationErrors.length) {
    throw feValidationErrors;
  }
  return true;
}

export const sanitizeRemoveSpaceFromStart = (value) => {
  if (!value) { return value };
  return value.trimStart();
}
export const sanitizeRemoveSpaceFromEnd = (value) => {
  if (!value) { return value };
  return value.trimEnd();
}
export const sanitizeRemoveDoubleSpaces = (value) => {
  if (!value) { return value };
  return value.replace(/ +(?= )/g, '');
}
